<app-header></app-header>
<ion-content
  id="customer-reporting"
  class="gray-content-bg"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
>
  <app-page-title-banner
    *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
    [pageTitle]="'Business Analytics'"
    [backgroundImageStyle]="backgroundImageStyle"
    [overlayGradient]="overlayGradient"
  ></app-page-title-banner>
  <div
    class="filter-header-container"
    *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
  >
    <ion-grid>
      <ng-container>
        <ion-row class="filtering-banner-container">
          <app-usf-filtering-banner-desktop
            class="filtering-banner-desktop"
            [isLoading]="false"
            [showQuickDateFilterOption]="true"
            [numberOfSelectedFilters]="numberSelectedFilters"
            (filterClicked)="openModal()"
            (changeDateFilterClicked)="openModal(true)"
            (resetFiltersClicked)="resetFilters()"
            [showResetFilterOption]="true"
            [resetLabel]="true"
            [filterDateRange]="deliveryDateRange"
          >
          </app-usf-filtering-banner-desktop>
        </ion-row>
      </ng-container>
    </ion-grid>
  </div>
  <ng-container *ngIf="(isAllFeaturesLoaded$ | async) && !showBusinessSkeleton">
    <ion-grid [fixed]="true">
      <ng-container>
        <ion-row
          class="filtering-banner-container"
          *ngIf="platformService?.platformType !== platformService?.platformEnum?.desktop"
        >
          <app-usf-filtering-banner-tablet
            *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
            [isLoading]="false"
            [showQuickDateFilterOption]="true"
            [numberOfSelectedFilters]="numberSelectedFilters"
            (filterClicked)="openModal()"
            (changeDateFilterClicked)="openModal(true)"
            (resetFiltersClicked)="resetFilters()"
            [showResetFilterOption]="true"
            [resetLabel]="true"
            [filterDateRange]="deliveryDateRange"
          >
          </app-usf-filtering-banner-tablet>
          <app-usf-filtering-banner-mobile
            *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
            [isLoading]="false"
            [showQuickDateFilterOption]="true"
            [numberOfSelectedFilters]="numberSelectedFilters"
            (filterClicked)="openModal()"
            (changeDateFilterClicked)="openModal(true)"
            (resetFiltersClicked)="resetFilters()"
            [showResetFilterOption]="true"
            [filterDateRange]="deliveryDateRange"
            [resetLabel]="true"
            [showDateRange]="true"
          >
          </app-usf-filtering-banner-mobile>
        </ion-row>
        <ion-row
          class="data-usage-warning-container"
          *ngIf="(platformService?.platformType === platformService?.platformEnum?.tablet) 
        || (platformService?.platformType === platformService?.platformEnum?.mobile)"
        >
          <app-data-usage-warning></app-data-usage-warning>
        </ion-row>
        <ion-row class="toast-container">
          <app-report-toast-container></app-report-toast-container>
        </ion-row>
        <ion-row
          class="analytics-banner-container"
          *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
        >
          <div class="analytics-banner-text">
            <h2>We've moved key reports into your dashboard!</h2>
            <p>
              Easier access, no need to switch platforms. Need more? Visit
              Legacy Business Analytics Site for all reports.
            </p>
          </div>
          <ion-button
            class="usf-fill-green-button"
            (click)="goToFullBusinessAnalytics()"
          >
            <span class="full-business-analytics-button-label"
              >Visit Legacy Business Analytics Site</span
            >
            <ion-icon
              slot="end"
              src="assets/icon/external-link-white.svg"
            ></ion-icon
          ></ion-button>
        </ion-row>
        <ion-row
          class="csv-report-container"
          [ngClass]="{'csv-flag-style-container': csvFlagStyle}"
          *ngIf="(showCsvs$ | async)"
        >
          <ion-col class="csv-report-container-header">
            <h2>
              Reports
              <span *ngIf="(isAnyTableViewActive$ | async) === false"
                >(.csv)</span
              >
            </h2>
          </ion-col>
          <ion-col
            class="csv-report-container-cards"
            [ngClass]="{'csv-flag-style': csvFlagStyle}"
            size="12"
          >
            <app-csv-download-card
              *ngFor="let report of filteredReports"
              [storedProcedure]="report.storedProcedure"
              [buttonLabel]="report.buttonLabel"
              [loadingState]="loadingState"
              [disabledState]="disabledState"
              [isTableViewActive]="(isTableViewEnabledForReport(report) | async)"
              (handleReport)="handleReportAction(report)"
              [ngClass]="{'csv-card-flag-style': csvFlagStyle}"
            >
            </app-csv-download-card>
          </ion-col>
        </ion-row>
        <ion-row
          class="category-report-container"
          *ngIf="isCategoryReportEnabled$ | async"
        >
          <div class="spend-by-category-title-container">
            <h2>Spend by Category with Year Over Year (YoY) Change</h2>
            <ion-segment
              data-cy="ar-aging-toggle"
              mode="ios"
              [value]="selectedSegment"
              (ionChange)="onSegmentChange($event)"
              [disabled]="isCategoryReportLoading$ | async"
            >
              <ion-segment-button
                data-cy="account-activity-toggle"
                [value]="'Dollars'"
              >
                <ion-label data-cy="account-activity-toggle-text">
                  $ Dollars
                </ion-label>
              </ion-segment-button>
              <ion-segment-button data-cy="ar-aging-toggle" [value]="'Cases'">
                <ion-label data-cy="new-ar-aging-text"> Cases </ion-label>
              </ion-segment-button>
            </ion-segment>
          </div>
          <app-category-report-chart
            *ngIf="(isCategoryReportLoading$ | async) === false"
            [cleanUp]="cleanUp"
            [sortBy]="selectedSegment"
          ></app-category-report-chart>
          <div
            class="graph-skeleton-container"
            *ngIf="isCategoryReportLoading$ | async"
          >
            <ion-skeleton-text
              *ngFor="let bar of platformService.platformType === platformService.platformEnum.mobile ? [1,2,3,4,5] : [1,2,3,4,5,6,7,8]"
              class="bar-skeleton"
              animated
            ></ion-skeleton-text>
          </div>
        </ion-row>
        <ion-row
          class="top-purchases-container"
          *ngIf="isPurchasesReportEnabled$ | async"
        >
          <div class="top-purchases-container-header">
            <h2>Top Purchases</h2>
            <ion-segment
              data-cy="top-purchases-toggle"
              mode="ios"
              [value]="topPurchasesSortBy"
              [disabled]="isTopPurchasesLoading$ | async"
              (ionChange)="onTopPurchasesSegmentChange($event)"
            >
              <ion-segment-button
                data-cy="top-purchases-dollars-toggle"
                [value]="'Dollars'"
              >
                <ion-label data-cy="top-purchases-dollars-toggle-text">
                  $ Dollars
                </ion-label>
              </ion-segment-button>
              <ion-segment-button
                data-cy="top-purchases-cases-toggle"
                [value]="'Cases'"
              >
                <ion-label data-cy="top-purchases-cases-toggle-text">
                  Cases
                </ion-label>
              </ion-segment-button>
            </ion-segment>
          </div>
          <ion-col *ngIf="(isTopPurchasesLoading$ | async) === false">
            <ng-container
              *ngIf="displayedTopPurchases && displayedTopPurchases.length > 0"
            >
              <app-top-purchases-card
                *ngFor="let purchase of displayedTopPurchases"
                [purchase]="purchase"
                [sortBy]="topPurchasesSortBy"
              >
              </app-top-purchases-card>
            </ng-container>
            <p *ngIf="showNoPurchasesMessage" class="no-purchases-message">
              There are no purchases available for the selected date range.
            </p>
          </ion-col>
          <ion-col
            *ngIf="isTopPurchasesLoading$ | async"
            class="purchases-skeleton-container"
          >
            <ion-skeleton-text
              *ngFor="let purchase of platformService.platformType === platformService.platformEnum.mobile ? [1,2,3] : [1,2,3,4,5,6,7,8,9,10]"
              class="purchase-skeleton"
              animated
            ></ion-skeleton-text>
          </ion-col>
          <div
            class="view-all-container"
            *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile && topPurchases?.length > 3"
          >
            <ion-button
              class="usf-fill-white-button"
              (click)="toggleShowAllTopPurchases()"
            >
              {{ showAllTopPurchasesMobile ? 'Show Less' : 'View All' }}
            </ion-button>
          </div>
        </ion-row>
      </ng-container>
    </ion-grid>
    <app-footer></app-footer>
  </ng-container>
  <div
    class="business-analytics-skeleton-container"
    *ngIf="showBusinessSkeleton"
  >
    <ion-grid>
      <ion-row>
        <div *ngFor="let row of [1,2,3]" class="skeleton-row">
          <ion-skeleton-text animated></ion-skeleton-text>
        </div>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
